import React from "react";
import { Link } from "react-router-dom";
import MESSAGES from "../../shared/constants/messages";

const AvisoSemServicos = ({ id, comLink }) => (
  <div className="alert lp-aviso-sem-servicos" role="alert">
    {MESSAGES.PEDIDOS_ALERT_TEXT}
    {comLink && (
      <>
        {" "}
        <Link id={id} to="/web-ordering">
          {MESSAGES.PEDIDOS_ALERT_LINK}
        </Link>
      </>
    )}
  </div>
);

export default AvisoSemServicos;
